import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const SvgChevronUpSingle = () => {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 30 30", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25.8999 19.45L15.45 9H14.45L4 19.45L4.975 20.4L14.95 12L24.9249 20.4L25.8999 19.45Z" }, void 0) }), void 0));
};
//# sourceMappingURL=chevron-up-single.js.map
